"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var MIGRATION_STATUSES;
(function (MIGRATION_STATUSES) {
    MIGRATION_STATUSES["NOT_STARTED"] = "not-started";
    MIGRATION_STATUSES["CREATED"] = "created";
    MIGRATION_STATUSES["IN_QUEUE"] = "in-queue";
    MIGRATION_STATUSES["IN_PROGRESS"] = "in-progress";
    MIGRATION_STATUSES["FINISHED"] = "finished";
    MIGRATION_STATUSES["FAILED"] = "failed";
})(MIGRATION_STATUSES = exports.MIGRATION_STATUSES || (exports.MIGRATION_STATUSES = {}));
//# sourceMappingURL=site-based-migration-statuses.js.map